export default __webpack_public_path__ + "static/media/1.9638f1c2.webp";